export interface DownloadRequest {
  path: string;
  token: string;
  fallbackName: string;
}

export interface DownloadPort {
  download(input: DownloadRequest): Promise<{ filename: string }>;
}

export function createBrowserDownloadPort(base = "/api"): DownloadPort {
  return {
    async download(input) {
      const response = await fetch(`${base}${input.path}`, {
        credentials: "include"
      });
      if (!response.ok) throw new Error("Download fehlgeschlagen");
      const disposition = response.headers.get("Content-Disposition") ?? "";
      const filename = disposition.match(/filename="([^"]+)"/)?.[1] ?? input.fallbackName;
      const url = URL.createObjectURL(await response.blob());
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
      return { filename };
    }
  };
}
